<div class="image-container">
  <img src="{{file}}" />
  <div class="caption">
    <span>Figure: </span><span><ng-content></ng-content></span>
  </div>
</div>

